import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MerchantStoreOnboardingComponent } from 'app/components/merchant/merchant-store-onboarding/merchant-store-onboarding.component';
import {
    ByMerchantRequestDto,
    MerchantVerificationCheckEnum,
    PayoutAccountStatusEnum,
    PayoutAccountType,
    PayoutAccountTypeEnum,
    WalletDetail,
    XpressUserRoleEnum
} from 'app/models';
import { AppDataService, MerchantService } from 'app/services';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'merchant-detail-payment',
    templateUrl: './merchant-detail-payment.component.html',
    styleUrls: ['./merchant-detail-payment.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'],
    providers: [MessageService]
})
export class MerchantDetailPaymentComponent implements OnInit {
    public merchantId: number = 0;
    @Input()
    set _merchantId(value: number) {
        this.merchantId = value;
        if (this.merchantId > 0) {
            this.getMerchantPayoutAccounts();
            this.getMerchantVerificationCheckLists();
        }
    }

    public merchantUserId: number = 0;
    @Input()
    set _merchantUserId(value: number) {
        this.merchantUserId = value;
    }

    public showMerchantDetailPaymentSideBar: boolean = false;
    @Input()
    set _showMerchantDetailPaymentSideBar(value: boolean) {
        this.showMerchantDetailPaymentSideBar = value;
    }

    @Input() public merchantStoreOnboardingComponent!: MerchantStoreOnboardingComponent;

    @Output() changedShowMerchantDetailPaymentSideBarEmit = new EventEmitter<boolean>();
    changedShowMerchantDetailPaymentSideBar(increased: any) {
        this.changedShowMerchantDetailPaymentSideBarEmit.emit(increased);
    }

    constructor(private messageService: MessageService,
        private merchantService: MerchantService,
        public appData: AppDataService) {
        this.isMerchant = this.appData.isMerchant();
    }

    public loading: boolean = false;

    public payment: any = {};
    public payoutAccountTypeEnum = PayoutAccountTypeEnum;
    public payoutAccountTypes = PayoutAccountType.PayoutAccountTypeList;
    public walletDetails = WalletDetail.WalletDetailList;

    public payoutAccountStatusEnum = PayoutAccountStatusEnum;

    public isMerchant: boolean = false;
    public xpressUserRoleEnum = XpressUserRoleEnum;

    ngOnInit(): void {}

    public getMerchantPayoutAccounts() {
        this.loading = true;
        const payload: ByMerchantRequestDto = {
            MerchantId: parseInt(this.appData.authData.MerchantId, 10)
        };
        this.merchantService.getMerchantPayoutAccounts(payload, this.messageService).then(data => {
            if (!data) {
                this.loading = false;
                return;
            }

            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.payment = data;
            this.loading = false;
        });
    }

    public questions: { name: string; question: string; checkId: MerchantVerificationCheckEnum; isChecked: boolean }[] = [
        {
            name: 'Is the address correct?', question: '',
            checkId: MerchantVerificationCheckEnum.IsTheAddressCorrect, isChecked: false
        },
        {
            name: 'Is the photo clear and accurate', question: '',
            checkId: MerchantVerificationCheckEnum.IsThePhotoClearAndAccurate, isChecked: false
        },
        {
            name: 'Lorem ipsum dolor', question: '',
            checkId: MerchantVerificationCheckEnum.LoremIpsumDolor, isChecked: false
        }
    ];
    getMerchantVerificationCheckLists() {
        const dto = {
            MerchantId: this.merchantId,
            MerchantPayoutAccountId: this.merchantId
        };

        this.loading = true;

        this.merchantService.getMerchantVerificationCheckLists(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                const questions = this.questions;

                data.Items.forEach((item: any) => {
                    const findItem = questions.find((obj) => {
                        const result = obj.checkId === item.CheckId;
                        return result;
                    });

                    if (findItem !== undefined) {
                        const index = questions.indexOf(findItem);
                        questions[index].isChecked = item.IsChecked;
                    }
                });
                this.checkVerificationForContinue();
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }
    checkVerificationForContinue() {
        let countIsChecked = 0;

        this.questions.forEach(q => {
            if (q.isChecked) {
                countIsChecked += 1;
            } else {
                countIsChecked -= (countIsChecked > 0) ? 1 : 0;
            }
        });
    }
    addOrUpdateMerchantVerificationCheckList(question: any) {
        const dto = {
            MerchantId: this.merchantId,
            MerchantPayoutAccountId: this.merchantId,
            CheckId: question.checkId,
            IsChecked: question.isChecked
        };

        this.merchantService.addOrUpdateMerchantVerificationCheckList(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    question.isChecked = false;
                    this.checkVerificationForContinue();
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data has been updated' });
                this.checkVerificationForContinue();
            })
            .catch(err => {
                question.isChecked = false;
                this.checkVerificationForContinue();
                throw err;
            });
    }
    public approvedOrReject(payoutAccountStatus: PayoutAccountStatusEnum) {
        const dto = {
            MerchantId: this.merchantId,
            RejectReason: this.payment.RejectReason,
            PayoutAccountStatusId: payoutAccountStatus
        };

        this.merchantService.approvedOrRejectMerchantPayoutAccountStatus(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data has been updated' });
                this.merchantStoreOnboardingComponent.getMerchantPayoutAccounts();
                this.changedShowMerchantDetailPaymentSideBar(false);
            });

    }

    cancel() {
        this.changedShowMerchantDetailPaymentSideBar(!this.showMerchantDetailPaymentSideBar);
    }
}
